/**
 * @generated SignedSource<<ee805ae35cad06de2d5e88e5df5e1eec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_platform",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableComplexMenu",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableSocialSharing",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderWithComplexMenuDesktop_platform"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderWithComplexMenuMobile_platform"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderWithSimpleMenu_platform"
    }
  ],
  "type": "Platform",
  "abstractKey": null
};

node.hash = "177f5d8e288688b9370c37cfd136072c";

module.exports = node;
